module.exports = __webpack_public_path__ + "static/media/Endoplasmático liso v2.b4c19f76.glb";